export default "__VITE_ASSET__Bm0nZQ$r__"